import { ApiServiceStore } from "./ApiServiceStore";
import { TRootStore } from "./RootStore";

export const IdentityApiServiceStore = (root: TRootStore) => {
    const baseStore = ApiServiceStore(root, "identityServiceApiUrl", "OAuthToken");

    return {
        get axiosInstance() {
            return baseStore.axiosInstance;
        },
        setBaseUrl(url: string) {
            baseStore.setBaseUrl(url);
        },
        initialize() {
            baseStore.initialize();
        }
    };
};
